import { Box, Typography } from "@mui/material";
import EmptyState from "./EmptyState";

/**
 * RecruiterLeaderboard — Phase 6 (Design Gap Audit item F.5) reusable component.
 *
 * Ranked recruiter list with a progress bar, matching the prototype's
 * leaderboard card. All entries and counts must be computed by the caller
 * from real, already-loaded candidate ownership data (recruiterName on
 * each candidate) — never hardcoded rankings.
 *
 * Props:
 *   entries - array of { name, submissions, selected }, PRE-SORTED by the
 *             caller (highest submissions first) (required, may be empty)
 */
export default function RecruiterLeaderboard({ entries }) {
  if (!entries || entries.length === 0) {
    return <EmptyState title="No recruiter activity yet" />;
  }

  const max = Math.max(...entries.map((e) => e.submissions), 1);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
      {entries.map((e, i) => (
        <Box
          key={e.name}
          sx={{ display: "flex", alignItems: "center", gap: 1.25 }}
        >
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 700,
              color: "text.secondary",
              width: 18,
            }}
          >
            {i + 1}
          </Typography>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 0.35,
              }}
            >
              <Typography
                sx={{
                  fontSize: 12.5,
                  fontWeight: 600,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {e.name}
              </Typography>
              <Typography
                sx={{ fontSize: 12, color: "text.secondary", flexShrink: 0 }}
              >
                {e.submissions} submitted · {e.selected} selected
              </Typography>
            </Box>
            <Box
              sx={{
                height: 6,
                borderRadius: "4px",
                bgcolor: "action.hover",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  width: `${Math.round((e.submissions / max) * 100)}%`,
                  bgcolor: "#2563eb",
                  borderRadius: "4px",
                }}
              />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
